// extracted by mini-css-extract-plugin
module.exports = {"container":"toc-module--container--anS8k","on":"toc-module--on--1XdL8","off":"toc-module--off--2BOWX","trigger":"toc-module--trigger--35RRi","tocs":"toc-module--tocs--3-Uen"};